import { useState, useCallback, useMemo } from "react";
import { AddCreativesWithWriterModal } from "components/modals/add-creatives-with-writer-modal/add-creatives-with-writer-modal";

type UseAddCreativesWithWriterModalProps = {
  folderId?: string;
};

export const useAddCreativesWithWriterModal = ({
  folderId,
}: UseAddCreativesWithWriterModalProps = {}) => {
  const [isAddCreativesWithWriterOpen, setIsAddCreativesWithWriterOpen] = useState(false);

  const openAddCreativesWithWriter = useCallback(() => setIsAddCreativesWithWriterOpen(true), []);
  const closeAddCreativesWithWriter = useCallback(
    () => setIsAddCreativesWithWriterOpen(false),
    [],
  );

  const addCreativesWithWriterModalMarkup = useMemo(() => {
    if (!isAddCreativesWithWriterOpen) return null;

    return (
      <AddCreativesWithWriterModal
        isOpen={isAddCreativesWithWriterOpen}
        setIsOpen={closeAddCreativesWithWriter}
        folderId={folderId}
      />
    );
  }, [isAddCreativesWithWriterOpen, closeAddCreativesWithWriter, folderId]);

  return {
    openAddCreativesWithWriter,
    closeAddCreativesWithWriter,
    addCreativesWithWriterModalMarkup,
  };
};
